import React from 'react';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { useDiscount } from '../../core/hooks/useDiscount';
import { useTranslation } from 'react-i18next';

export const DiscountsTable: React.FC = () => {
  const { discounts, remove: discountRemove, loading } = useDiscount();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Paper style={{ width: '60vw', overflowY: 'hidden' }}>
      <Toolbar
        style={{ padding: 10, backgroundColor: '#3f51b5', color: 'white' }}
      >
        <Typography
          style={{ flex: '1 1 100%' }}
          color="inherit"
          variant="h5"
          component="div"
        >
          {t('discount:discounts')}
        </Typography>
        <Tooltip title={<React.Fragment>{t('global:add')}</React.Fragment>}>
          <IconButton
            style={{ color: 'white' }}
            aria-label="add"
            onClick={() => history.push(history.location.pathname + `/add`)}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
      <TableContainer>
        <Table>
          <TableHead>
            {loading ? null : (
              <TableRow>
                <TableCell>{t('discount:timeCreated')}</TableCell>
                <TableCell>{t('discount:code')}</TableCell>
                <TableCell>{t('discount:amount')}</TableCell>
                <TableCell
                  style={{
                    borderLeftWidth: 0,
                  }}
                ></TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell align="center">
                  <CircularProgress color="inherit" />
                </TableCell>
              </TableRow>
            ) : (
              discounts.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {new Date(row.timeCreated).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{row.code}</TableCell>
                  <TableCell>
                    {row.flatDiscount
                      ? row.flatDiscount + ' ' + t('global:moneyValute')
                      : row.percentageDiscount
                      ? row.percentageDiscount + '%'
                      : ''}
                  </TableCell>
                  <TableCell
                    style={{
                      borderLeftWidth: 0,
                      minWidth: 80,
                    }}
                    align="right"
                  >
                    <Tooltip
                      style={{ marginRight: 5 }}
                      title={
                        <React.Fragment>{t('global:edit')}</React.Fragment>
                      }
                    >
                      <IconButton
                        aria-label="edit"
                        onClick={() =>
                          history.push(history.location.pathname + `/${row.id}`)
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      title={
                        <React.Fragment>{t('global:delete')}</React.Fragment>
                      }
                    >
                      <IconButton
                        aria-label="delete"
                        onClick={async (event) => {
                          discountRemove(row.id);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
